// spendLabels.js — human-readable spend-category labels, shared by EVERY surface
// so no raw Plaid enum (FOOD_AND_DRINK, TRANSFER_OUT, GENERAL_MERCHANDISE, ...)
// ever reaches Kai or the user. Lives in src/lib so the client (Scorify.jsx) and
// the server (api/lib/spend.js re-exports it; coach-run.js and notify-cron use it)
// share one mapping.
//
// DISPLAY ONLY. This never decides whether a transaction counts as spend — that is
// isExcludedFromSpend / isSpendTx (the matched pair in api/lib/spend.js and
// src/Scorify.jsx). The TRANSFER_OUT buckets split here (Cash & ATM, Payments to
// people) are the ones that already COUNT as spend; the self-transfer detailed
// buckets are excluded upstream and never reach a label, but "Transfers out" is a
// safe catch-all if one ever does.

const PRIMARY_LABELS = {
  INCOME: 'Income',
  TRANSFER_IN: 'Transfers in',
  LOAN_PAYMENTS: 'Loan payments',
  BANK_FEES: 'Bank fees',
  ENTERTAINMENT: 'Entertainment',
  FOOD_AND_DRINK: 'Food & drink',
  GENERAL_MERCHANDISE: 'Shopping',
  HOME_IMPROVEMENT: 'Home improvement',
  MEDICAL: 'Medical',
  PERSONAL_CARE: 'Personal care',
  GENERAL_SERVICES: 'Services',
  GOVERNMENT_AND_NON_PROFIT: 'Government & non-profit',
  TRANSPORTATION: 'Transportation',
  TRAVEL: 'Travel',
  RENT_AND_UTILITIES: 'Rent & utilities',
};

// Same reader semantics as spendCategory / isSpendTx: PFC primary, then the
// legacy category[0] fallback. Kept inline so this module stands alone (the
// client cannot import api/lib).
const readPrimary = (t) =>
  t?.personal_finance_category?.primary || (Array.isArray(t?.category) ? t.category[0] : '') || '';

// Title-cases any enum we do not have an explicit label for, and any legacy
// category[0] string, so a raw UPPER_SNAKE value can never leak through.
const humanize = (s) =>
  !s ? 'Other' : String(s).replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

export function spendCategoryLabel(t) {
  const primary = readPrimary(t);
  if (primary === 'TRANSFER_OUT') {
    const detailed = t?.personal_finance_category?.detailed || '';
    if (detailed === 'TRANSFER_OUT_WITHDRAWAL') return 'Cash & ATM';
    if (detailed === 'TRANSFER_OUT_TRANSFER_OUT_FROM_APPS') return 'Payments to people';
    return 'Transfers out';
  }
  return PRIMARY_LABELS[primary] || humanize(primary);
}
